import { LegalPage } from "@/components/legal/LegalPage";
import { COMPANY } from "@/lib/company";

export default function Privacy() {
  return (
    <LegalPage title="Politica de confidențialitate" updated="iunie 2026">
      <h2>1. Operatorul de date</h2>
      <p>
        Operatorul datelor cu caracter personal este <strong>{COMPANY.legalName}</strong>, CUI <strong>{COMPANY.cui}</strong>,
        nr. înreg. <strong>{COMPANY.regNo}</strong>, e-mail {COMPANY.email}, telefon {COMPANY.phone}.
        Prelucrăm datele în conformitate cu Regulamentul (UE) 2016/679 (GDPR).
      </p>

      <h2>2. Ce date colectăm</h2>
      <ul>
        <li>Date de identificare și contact: nume, prenume, telefon, adresă de livrare;</li>
        <li>Date privind comenzile: produse comandate, valoare, istoric;</li>
        <li>Date tehnice: adresă IP, tip dispozitiv, cookie-uri (vezi Politica de cookies).</li>
      </ul>

      <h2>3. Scopul prelucrării</h2>
      <ul>
        <li>Procesarea și livrarea comenzilor;</li>
        <li>Comunicarea cu privire la comenzi și asistență clienți;</li>
        <li>Îndeplinirea obligațiilor legale (fiscale, contabile);</li>
        <li>Îmbunătățirea serviciilor și a experienței pe site.</li>
      </ul>

      <h2>4. Temeiul legal</h2>
      <p>
        Prelucrarea se bazează pe executarea contractului (comanda dumneavoastră), pe obligațiile legale ale
        operatorului și, după caz, pe consimțământ.
      </p>

      <h2>5. Durata stocării</h2>
      <p>
        Datele sunt păstrate pe durata necesară îndeplinirii scopurilor și conform termenelor legale de arhivare.
      </p>

      <h2>6. Divulgarea datelor</h2>
      <p>
        Datele pot fi transmise firmelor de curierat (pentru livrare) și autorităților, atunci când legea o impune.
        Nu vindem datele dumneavoastră către terți.
      </p>

      <h2>7. Drepturile dumneavoastră</h2>
      <p>
        Aveți dreptul de acces, rectificare, ștergere, restricționare, portabilitate, opoziție și dreptul de a vă
        retrage consimțământul. Pentru exercitarea acestor drepturi, ne puteți scrie la {COMPANY.email}.
        De asemenea, aveți dreptul de a depune o plângere la Autoritatea Națională de Supraveghere a Prelucrării
        Datelor cu Caracter Personal (ANSPDCP).
      </p>

      <h2>8. Securitate</h2>
      <p>
        Aplicăm măsuri tehnice și organizatorice rezonabile pentru protejarea datelor împotriva accesului neautorizat,
        pierderii sau divulgării.
      </p>
    </LegalPage>
  );
}
